export class InvestigationPrioritySnapshotEntity {
  public id!: string;
  public priority!: string;
  public name!: string;
  public code!: string;
  public sortOrder!: number;
  public timeToResolveHours!: number;
  public atRiskThresholdPercent!: number;
  public isActive!: boolean;
}
